import { components } from '@/utils'

export default function(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy,
        label: this.getTranslate('filter.preset'),
        items: this.items,
        labelMode: this.labelMode,
        details: false,
        dense: true
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
